import * as types from "../../mutation-types";
import {removeItem, addOrUpdateItem} from "../../helpers";

export default {
    [types.ADD_OR_UPDATE_TEAM]: (state, item) => addOrUpdateItem(state, item),
    [types.REMOVE_TEAM]: (state, item) => removeItem(state, item)
}